import { useState, useEffect } from "react";
import React from "react";
import {
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  Font,
  StyleSheet,
  Image,
  PDFViewer,
} from "@react-pdf/renderer";

import { FontRegister, DocStyles, LogoTavad } from "./DocStyles";

import { FormatDate } from "./FormatDate";

import { useLoaderData, useParams } from "react-router-dom";

import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";

import hlaLogo from ".//images/hla-logo.png";

import servMedTavad from ".//images/servicio-medico-tavad-firma.jpg";

export function CuestSaludField({
  updateData,
  autoEspecialistaData,
  autoPacienteData,
  savedData,
}) {
  // Set default valor for today date
  const todayDate = new Date()
    .toISOString()
    .replace(/T.*/, "")
    .split("-")
    .join("-");

  let especialistaFullName = autoEspecialistaData
    ? autoEspecialistaData?.first_name + " " + autoEspecialistaData?.last_name
    : undefined;
  let pacienteFullName = autoPacienteData
    ? autoPacienteData?.first_name + " " + autoPacienteData?.last_name
    : undefined;
  let pacienteFullDireccion =
    autoPacienteData?.meta?.direccion +
    ", " +
    autoPacienteData?.meta?.direccion_num +
    ", " +
    autoPacienteData?.meta?.direccion_piso;

  // Calcular edad del paciente restando a la fecha actual la fecha de nacimiento del paciente
  let pacienteEdad;
  if (autoPacienteData?.meta?.nacimiento) {
    const fechaNacimiento = new Date(autoPacienteData.meta.nacimiento);
    const hoy = new Date();

    let edad = hoy.getFullYear() - fechaNacimiento.getFullYear();
    const mes = hoy.getMonth() - fechaNacimiento.getMonth();

    // Ajuste de la edad si aún no ha pasado el cumpleaños en el año actual
    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNacimiento.getDate())) {
      edad--;
    }

    pacienteEdad = edad;
  } else {
    pacienteEdad = "Fecha de nacimiento no disponible";
  }

  const [docFecha, setDocFecha] = useState(
    savedData?.docFecha ? savedData?.docFecha : todayDate
  );
  const [docPacie, setDocPacie] = useState(
    savedData?.docPacie ? savedData?.docPacie : pacienteFullName
  );

  const [docSexo, setDocSexo] = useState(
    savedData?.docSexo
      ? savedData?.docSexo
      : autoPacienteData?.meta?.sexo_paciente
  );

  const [docEdad, setDocEdad] = useState(
    savedData?.docEdad ? String(savedData.docEdad) : String(pacienteEdad)
  );
  const [docDirecc, setDocDirecc] = useState(
    savedData?.docDirecc ? savedData?.docDirecc : pacienteFullDireccion
  );

  const [docPobl, setDocPobl] = useState(
    savedData?.docPobl
      ? savedData?.docPobl
      : autoPacienteData?.meta?.direccion_ciudad
  );

  const [docPais, setDocPais] = useState(
    savedData?.docPais ? savedData?.docPais : undefined
  );

  const [docTelefono, setDocTelefono] = useState(
    savedData?.docTelefono
      ? savedData?.docTelefono
      : autoPacienteData?.meta?.telefono
  );

  const [docEmail, setDocEmail] = useState(
    savedData?.docEmail ? savedData?.docEmail : autoPacienteData?.email
  );

  const [docNombreFamiliar, setDocNombreFamiliar] = useState(
    savedData?.docNombreFamiliar
      ? savedData?.docNombreFamiliar
      : autoPacienteData?.meta?.nombre_familiar
  );

  const [docTelFamiliar, setDocTelFamiliar] = useState(
    savedData?.docTelFamiliar
      ? savedData?.docTelFamiliar
      : autoPacienteData?.meta?.telefono_familiar
  );

  const [docEmbarazRad, setDocEmbarazRad] = useState(
    savedData?.docEmbarazRad ? savedData?.docEmbarazRad : undefined
  );

  const [docAlergiaRad, setDocAlergiaRad] = useState(
    savedData?.docAlergiaRad ? savedData?.docAlergiaRad : undefined
  );

  const [docAlergiaResp, setDocAlergiaResp] = useState(
    savedData?.docAlergiaResp ? savedData?.docAlergiaResp : undefined
  );

  const [docDefSensRad, setDocDefSensRad] = useState(
    savedData?.docDefSensRad ? savedData?.docDefSensRad : undefined
  );

  const [docDefSensResp, setDocDefSensResp] = useState(
    savedData?.docDefSensResp ? savedData?.docDefSensResp : undefined
  );

  const [docIntHospRad, setDocIntHospRad] = useState(
    savedData?.docIntHospRad ? savedData?.docIntHospRad : undefined
  );

  const [docIntHospCuando, setDocIntHospCuando] = useState(
    savedData?.docIntHospCuando ? savedData?.docIntHospCuando : undefined
  );

  const [docIntHospMotivo, setDocIntHospMotivo] = useState(
    savedData?.docIntHospMotivo ? savedData?.docIntHospMotivo : undefined
  );

  const [docLesCabezRad, setDocLesCabezRad] = useState(
    savedData?.docLesCabezRad ? savedData?.docLesCabezRad : undefined
  );

  const [docLesCabezResp, setDocLesCabezResp] = useState(
    savedData?.docLesCabezResp ? savedData?.docLesCabezResp : undefined
  );

  const [docDesmRad, setDocDesmRad] = useState(
    savedData?.docDesmRad ? savedData?.docDesmRad : undefined
  );

  const [docDesmCuando, setDocDesmCuando] = useState(
    savedData?.docDesmCuando ? savedData?.docDesmCuando : undefined
  );

  const [docDesmTiempo, setDocDesmTiempo] = useState(
    savedData?.docDesmTiempo ? savedData?.docDesmTiempo : undefined
  );

  const [docDesmMotivo, setDocDesmMotivo] = useState(
    savedData?.docDesmMotivo ? savedData?.docDesmMotivo : undefined
  );

  const [docConvRad, setDocConvRad] = useState(
    savedData?.docConvRad ? savedData?.docConvRad : undefined
  );

  const [docConvCuando, setDocConvCuando] = useState(
    savedData?.docConvCuando ? savedData?.docConvCuando : undefined
  );

  const [docConvCuantas, setDocConvCuantas] = useState(
    savedData?.docConvCuantas ? savedData?.docConvCuantas : undefined
  );

  const [docEnfCorazonRad, setDocEnfCorazonRad] = useState(
    savedData?.docEnfCorazonRad ? savedData?.docEnfCorazonRad : undefined
  );

  const [docEnfCorazonResp, setDocEnfCorazonResp] = useState(
    savedData?.docEnfCorazonResp ? savedData?.docEnfCorazonResp : undefined
  );

  const [docEnfHigadoRad, setDocEnfHigadoRad] = useState(
    savedData?.docEnfHigadoRad ? savedData?.docEnfHigadoRad : undefined
  );

  const [docEnfHigadoResp, setDocEnfHigadoResp] = useState(
    savedData?.docEnfHigadoResp ? savedData?.docEnfHigadoResp : undefined
  );

  const [docEnfPulmonesRad, setDocEnfPulmonesRad] = useState(
    savedData?.docEnfPulmonesRad ? savedData?.docEnfPulmonesRad : undefined
  );

  const [docEnfPulmonesResp, setDocEnfPulmonesResp] = useState(
    savedData?.docEnfPulmonesResp ? savedData?.docEnfPulmonesResp : undefined
  );

  const [docEnfRinonesRad, setDocEnfRinonesRad] = useState(
    savedData?.docEnfRinonesRad ? savedData?.docEnfRinonesRad : undefined
  );

  const [docEnfRinonesResp, setDocEnfRinonesResp] = useState(
    savedData?.docEnfRinonesResp ? savedData?.docEnfRinonesResp : undefined
  );

  const [docEnfEstomagoRad, setDocEnfEstomagoRad] = useState(
    savedData?.docEnfEstomagoRad ? savedData?.docEnfEstomagoRad : undefined
  );

  const [docEnfEstomagoResp, setDocEnfEstomagoResp] = useState(
    savedData?.docEnfEstomagoResp ? savedData?.docEnfEstomagoResp : undefined
  );

  const [docDiabetRad, setDocDiabetRad] = useState(
    savedData?.docDiabetRad ? savedData?.docDiabetRad : undefined
  );

  const [docHipertRad, setDocHipertRad] = useState(
    savedData?.docHipertRad ? savedData?.docHipertRad : undefined
  );

  const [docHipertResp, setDocHipertResp] = useState(
    savedData?.docHipertResp ? savedData?.docHipertResp : undefined
  );

  const [docAsmaRad, setDocAsmaRad] = useState(
    savedData?.docAsmaRad ? savedData?.docAsmaRad : undefined
  );

  const [docEnfPsiqRad, setDocEnfPsiqRad] = useState(
    savedData?.docEnfPsiqRad ? savedData?.docEnfPsiqRad : undefined
  );

  const [docEnfPsiqResp, setDocEnfPsiqResp] = useState(
    savedData?.docEnfPsiqaResp ? savedData?.docEnfPsiqResp : undefined
  );

  const [docMetadonaDiaria, setDocMetadonaDiaria] = useState(
    savedData?.docMetadonaDiaria ? savedData?.docMetadonaDiaria : undefined
  );

  const [docMetadonaCuando, setDocMetadonaCuando] = useState(
    savedData?.docMetadonaCuando ? savedData?.docMetadonaCuando : undefined
  );

  const [docHeroinaDiaria, setDocHeroinaDiaria] = useState(
    savedData?.docHeroinaDiaria ? savedData?.docHeroinaDiaria : undefined
  );

  const [docHeroinaCuando, setDocHeroinaCuando] = useState(
    savedData?.docHeroinaCuando ? savedData?.docHeroinaCuando : undefined
  );

  const [docCodeinaDiaria, setDocCodeinaDiaria] = useState(
    savedData?.docCodeinaDiaria ? savedData?.docCodeinaDiaria : undefined
  );

  const [docCodeinaCuando, setDocCodeinaCuando] = useState(
    savedData?.docCodeinaCuando ? savedData?.docCodeinaCuando : undefined
  );

  const [docMorfinaDiaria, setDocMorfinaDiaria] = useState(
    savedData?.docMorfinaDiaria ? savedData?.docMorfinaDiaria : undefined
  );

  const [docMorfinaCuando, setDocMorfinaCuando] = useState(
    savedData?.docMorfinaCuando ? savedData?.docMorfinaCuando : undefined
  );

  const [docCocainaDiaria, setDocCocainaDiaria] = useState(
    savedData?.docCocainaDiaria ? savedData?.docCocainaDiaria : undefined
  );

  const [docCocainaCuando, setDocCocainaCuando] = useState(
    savedData?.docCocainaCuando ? savedData?.docCocainaCuando : undefined
  );

  const [docAnfetaminasDiaria, setDocAnfetaminasDiaria] = useState(
    savedData?.docAnfetaminasDiaria
      ? savedData?.docAnfetaminasDiaria
      : undefined
  );

  const [docAnfetaminasCuando, setDocAnfetaminasCuando] = useState(
    savedData?.docAnfetaminasCuando
      ? savedData?.docAnfetaminasCuando
      : undefined
  );

  const [docLsdDiaria, setDocLsdDiaria] = useState(
    savedData?.docLsdDiaria ? savedData?.docLsdDiaria : undefined
  );

  const [docLsdCuando, setDocLsdCuando] = useState(
    savedData?.docLsdCuando ? savedData?.docLsdCuando : undefined
  );

  const [docExtasisDiaria, setDocExtasisDiaria] = useState(
    savedData?.docExtasisDiaria ? savedData?.docExtasisDiaria : undefined
  );

  const [docExtasisCuando, setDocExtasisCuando] = useState(
    savedData?.docExtasisCuando ? savedData?.docExtasisCuando : undefined
  );

  const [docCannabisDiaria, setDocCannabisDiaria] = useState(
    savedData?.docCannabisDiaria ? savedData?.docCannabisDiaria : undefined
  );

  const [docCannabisCuando, setDocCannabisCuando] = useState(
    savedData?.docCannabisCuando ? savedData?.docCannabisCuando : undefined
  );

  const [docBenzodiazepinasUnoDiaria, setDocBenzodiazepinasUnoDiaria] =
    useState(
      savedData?.docBenzodiazepinasUnoDiaria
        ? savedData?.docBenzodiazepinasUnoDiaria
        : undefined
    );

  const [docBenzodiazepinasUnoCuando, setDocBenzodiazepinasUnoCuando] =
    useState(
      savedData?.docBenzodiazepinasUnoCuando
        ? savedData?.docBenzodiazepinasUnoCuando
        : undefined
    );

  const [docBenzodiazepinasDosDiaria, setDocBenzodiazepinasDosDiaria] =
    useState(
      savedData?.docBenzodiazepinasDosDiaria
        ? savedData?.docBenzodiazepinasDosDiaria
        : undefined
    );

  const [docBenzodiazepinasDosCuando, setDocBenzodiazepinasDosCuando] =
    useState(
      savedData?.docBenzodiazepinasDosCuando
        ? savedData?.docBenzodiazepinasDosCuando
        : undefined
    );

  const [docBenzodiazepinasTresDiaria, setDocBenzodiazepinasTresDiaria] =
    useState(
      savedData?.docBenzodiazepinasTresDiaria
        ? savedData?.docBenzodiazepinasTresDiaria
        : undefined
    );

  const [docBenzodiazepinasTresCuando, setDocBenzodiazepinasTresCuando] =
    useState(
      savedData?.docBenzodiazepinasTresCuando
        ? savedData?.docBenzodiazepinasTresCuando
        : undefined
    );

  const [docWhiskyDiaria, setDocWhiskyDiaria] = useState(
    savedData?.docWhiskyDiaria ? savedData?.docWhiskyDiaria : undefined
  );

  const [docWhiskyCuando, setDocWhiskyCuando] = useState(
    savedData?.docWhiskyCuando ? savedData?.docWhiskyCuando : undefined
  );

  const [docVinoDiaria, setDocVinoDiaria] = useState(
    savedData?.docVinoDiaria ? savedData?.docVinoDiaria : undefined
  );

  const [docVinoCuando, setDocVinoCuando] = useState(
    savedData?.docVinoCuando ? savedData?.docVinoCuando : undefined
  );

  const [docCervezaDiaria, setDocCervezaDiaria] = useState(
    savedData?.docCervezaDiaria ? savedData?.docCervezaDiaria : undefined
  );

  const [docCervezaCuando, setDocCervezaCuando] = useState(
    savedData?.docCervezaCuando ? savedData?.docCervezaCuando : undefined
  );

  const [docAlcoholOtrosDiaria, setDocAlcoholOtrosDiaria] = useState(
    savedData?.docAlcoholOtrosDiaria
      ? savedData?.docAlcoholOtrosDiaria
      : undefined
  );

  const [docAlcoholOtrosCuando, setDocAlcoholOtrosCuando] = useState(
    savedData?.docAlcoholOtrosCuando
      ? savedData?.docAlcoholOtrosCuando
      : undefined
  );

  const [docOtraDrogaUnoDiaria, setDocOtraDrogaUnoDiaria] = useState(
    savedData?.docOtraDrogaUnoDiaria
      ? savedData?.docOtraDrogaUnoDiaria
      : undefined
  );

  const [docOtraDrogaUnoCuando, setDocOtraDrogaUnoCuando] = useState(
    savedData?.docOtraDrogaUnoCuando
      ? savedData?.docOtraDrogaUnoCuando
      : undefined
  );

  const [docOtraDrogaDosDiaria, setDocOtraDrogaDosDiaria] = useState(
    savedData?.docOtraDrogaDosDiaria
      ? savedData?.docOtraDrogaDosDiaria
      : undefined
  );

  const [docOtraDrogaDosCuando, setDocOtraDrogaDosCuando] = useState(
    savedData?.docOtraDrogaDosCuando
      ? savedData?.docOtraDrogaDosCuando
      : undefined
  );

  const [docInfoConsDroga, setDocInfoConsDroga] = useState(
    savedData?.docInfoConsDroga ? savedData?.docInfoConsDroga : undefined
  );

  const [docMedicacionRad, setDocMedicacionRad] = useState(
    savedData?.docMedicacionRad ? savedData?.docMedicacionRad : undefined
  );

  const [docMedicacionResp, setDocMedicacionResp] = useState(
    savedData?.docMedicacionResp ? savedData?.docMedicacionResp : undefined
  );

  const [docRehabRad, setDocRehabRad] = useState(
    savedData?.docRehabRad ? savedData?.docRehabRad : undefined
  );

  const [docRehabResp, setDocRehabResp] = useState(
    savedData?.docRehabResp ? savedData?.docRehabResp : undefined
  );

  let data = {
    docFecha: docFecha,
    docPacie: docPacie,
    docEdad: docEdad,
    docSexo: docSexo,
    docDirecc: docDirecc,
    docPobl: docPobl,
    docPais: docPais,
    docTelefono: docTelefono,
    docEmail: docEmail,
    docNombreFamiliar: docNombreFamiliar,
    docTelFamiliar: docTelFamiliar,
    docEmbarazRad: docEmbarazRad,
    docAlergiaRad: docAlergiaRad,
    docAlergiaResp: docAlergiaResp,
    docDefSensRad: docDefSensRad,
    docDefSensResp: docDefSensResp,
    docIntHospRad: docIntHospRad,
    docIntHospCuando: docIntHospCuando,
    docIntHospMotivo: docIntHospMotivo,
    docLesCabezRad: docLesCabezRad,
    docLesCabezResp: docLesCabezResp,
    docDesmRad: docDesmRad,
    docDesmCuando: docDesmCuando,
    docDesmTiempo: docDesmTiempo,
    docDesmMotivo: docDesmMotivo,
    docConvRad: docConvRad,
    docConvCuando: docConvCuando,
    docConvCuantas: docConvCuantas,
    docEnfCorazonRad: docEnfCorazonRad,
    docEnfCorazonResp: docEnfCorazonResp,
    docEnfHigadoRad: docEnfHigadoRad,
    docEnfHigadoResp: docEnfHigadoResp,
    docEnfPulmonesRad: docEnfPulmonesRad,
    docEnfPulmonesResp: docEnfPulmonesResp,
    docEnfRinonesRad: docEnfRinonesRad,
    docEnfRinonesResp: docEnfRinonesResp,
    docEnfEstomagoRad: docEnfEstomagoRad,
    docEnfEstomagoResp: docEnfEstomagoResp,
    docDiabetRad: docDiabetRad,
    docHipertRad: docHipertRad,
    docHipertResp: docHipertResp,
    docAsmaRad: docAsmaRad,
    docEnfPsiqRad: docEnfPsiqRad,
    docEnfPsiqResp: docEnfPsiqResp,
    docMetadonaDiaria: docMetadonaDiaria,
    docMetadonaCuando: docMetadonaCuando,
    docHeroinaDiaria: docHeroinaDiaria,
    docHeroinaCuando: docHeroinaCuando,
    docCodeinaDiaria: docCodeinaDiaria,
    docCodeinaCuando: docCodeinaCuando,
    docMorfinaDiaria: docMorfinaDiaria,
    docMorfinaCuando: docMorfinaCuando,
    docCocainaDiaria: docCocainaDiaria,
    docCocainaCuando: docCocainaCuando,
    docAnfetaminasDiaria: docAnfetaminasDiaria,
    docAnfetaminasCuando: docAnfetaminasCuando,
    docLsdDiaria: docLsdDiaria,
    docLsdCuando: docLsdCuando,
    docExtasisDiaria: docExtasisDiaria,
    docExtasisCuando: docExtasisCuando,
    docCannabisDiaria: docCannabisDiaria,
    docCannabisCuando: docCannabisCuando,
    docBenzodiazepinasUnoDiaria: docBenzodiazepinasUnoDiaria,
    docBenzodiazepinasUnoCuando: docBenzodiazepinasUnoCuando,
    docBenzodiazepinasDosDiaria: docBenzodiazepinasDosDiaria,
    docBenzodiazepinasDosCuando: docBenzodiazepinasDosCuando,
    docBenzodiazepinasTresDiaria: docBenzodiazepinasTresDiaria,
    docBenzodiazepinasTresCuando: docBenzodiazepinasTresCuando,
    docWhiskyDiaria: docWhiskyDiaria,
    docWhiskyCuando: docWhiskyCuando,
    docVinoDiaria: docVinoDiaria,
    docVinoCuando: docVinoCuando,
    docCervezaDiaria: docCervezaDiaria,
    docCervezaCuando: docCervezaCuando,
    docAlcoholOtrosDiaria: docAlcoholOtrosDiaria,
    docAlcoholOtrosCuando: docAlcoholOtrosCuando,
    docOtraDrogaUnoDiaria: docOtraDrogaUnoDiaria,
    docOtraDrogaUnoCuando: docOtraDrogaUnoCuando,
    docOtraDrogaDosDiaria: docOtraDrogaDosDiaria,
    docOtraDrogaDosCuando: docOtraDrogaDosCuando,
    docInfoConsDroga: docInfoConsDroga,
    docMedicacionRad: docMedicacionRad,
    docMedicacionResp: docMedicacionResp,
    docRehabRad: docRehabRad,
    docRehabResp: docRehabResp,
  };

  useEffect(() => {
    updateData(data);
  }, [
    docFecha,
    docPacie,
    docEdad,
    docSexo,
    docDirecc,
    docPobl,
    docPais,
    docTelefono,
    docEmail,
    docNombreFamiliar,
    docTelFamiliar,
    docEmbarazRad,
    docAlergiaRad,
    docAlergiaResp,
    docDefSensRad,
    docDefSensResp,
    docIntHospRad,
    docIntHospCuando,
    docIntHospMotivo,
    docLesCabezRad,
    docLesCabezResp,
    docDesmRad,
    docDesmCuando,
    docDesmTiempo,
    docDesmMotivo,
    docConvRad,
    docConvCuando,
    docConvCuantas,
    docEnfCorazonRad,
    docEnfCorazonResp,
    docEnfHigadoRad,
    docEnfHigadoResp,
    docEnfPulmonesRad,
    docEnfPulmonesResp,
    docEnfRinonesRad,
    docEnfRinonesResp,
    docEnfEstomagoRad,
    docEnfEstomagoResp,
    docDiabetRad,
    docHipertRad,
    docHipertResp,
    docAsmaRad,
    docEnfPsiqRad,
    docEnfPsiqResp,
    docMetadonaDiaria,
    docMetadonaCuando,
    docHeroinaDiaria,
    docHeroinaCuando,
    docCodeinaDiaria,
    docCodeinaCuando,
    docMorfinaDiaria,
    docMorfinaCuando,
    docCocainaDiaria,
    docCocainaCuando,
    docAnfetaminasDiaria,
    docAnfetaminasCuando,
    docLsdDiaria,
    docLsdCuando,
    docExtasisDiaria,
    docExtasisCuando,
    docCannabisDiaria,
    docCannabisCuando,
    docBenzodiazepinasUnoDiaria,
    docBenzodiazepinasUnoCuando,
    docBenzodiazepinasDosDiaria,
    docBenzodiazepinasDosCuando,
    docBenzodiazepinasTresDiaria,
    docBenzodiazepinasTresCuando,
    docWhiskyDiaria,
    docWhiskyCuando,
    docVinoDiaria,
    docVinoCuando,
    docCervezaDiaria,
    docCervezaCuando,
    docAlcoholOtrosDiaria,
    docAlcoholOtrosCuando,
    docOtraDrogaUnoDiaria,
    docOtraDrogaUnoCuando,
    docOtraDrogaDosDiaria,
    docOtraDrogaDosCuando,
    docInfoConsDroga,
    docMedicacionRad,
    docMedicacionResp,
    docRehabRad,
    docRehabResp,
  ]);

  // Data for docx generator
  const [showDocxLink, setShowDocxLink] = useState(false);

  const generateDocx = async () => {
    try {
      const response = await fetch(
        "https://app.tavad.com/documentacion-templates/CuestSalud.docx"
        //"https://silocreativo.win/docx/CuestSalud.docx"
      );

      const blob = await response.blob();
      const arrayBuffer = await new Response(blob).arrayBuffer();

      const zip = new PizZip(arrayBuffer);
      const doc = new Docxtemplater(zip, {
        nullGetter() {
          return "XXXXXXXXX";
        },
      });

      const sexoHombre = docSexo === "hombre" ? "✅" : "⬜";
      const sexoMujer = docSexo === "mujer" ? "✅" : "⬜";

      const embarazSi = docEmbarazRad === "Si" ? "✅" : "⬜";
      const embarazNo = docEmbarazRad === "No" ? "✅" : "⬜";

      const alergiaSi = docAlergiaRad === "Si" ? "✅" : "⬜";
      const alergiaNo = docAlergiaRad === "No" ? "✅" : "⬜";

      const defSensSi = docDefSensRad === "Si" ? "✅" : "⬜";
      const defSensNo = docDefSensRad === "No" ? "✅" : "⬜";

      const intHospSi = docIntHospRad === "Si" ? "✅" : "⬜";
      const intHospNo = docIntHospRad === "No" ? "✅" : "⬜";

      const lesCabezSi = docLesCabezRad === "Si" ? "✅" : "⬜";
      const lesCabezNo = docLesCabezRad === "No" ? "✅" : "⬜";

      const desmSi = docDesmRad === "Si" ? "✅" : "⬜";
      const desmNo = docDesmRad === "No" ? "✅" : "⬜";

      const convSi = docConvRad === "Si" ? "✅" : "⬜";
      const convNo = docConvRad === "No" ? "✅" : "⬜";

      const enfCorazonSi = docEnfCorazonRad === "Si" ? "✅" : "⬜";
      const enfCorazonNo = docEnfCorazonRad === "No" ? "✅" : "⬜";

      const enfHigadoSi = docEnfHigadoRad === "Si" ? "✅" : "⬜";
      const enfHigadoNo = docEnfHigadoRad === "No" ? "✅" : "⬜";

      const enfPulmonesSi = docEnfPulmonesRad === "Si" ? "✅" : "⬜";
      const enfPulmonesNo = docEnfPulmonesRad === "No" ? "✅" : "⬜";

      const enfRinonesSi = docEnfRinonesRad === "Si" ? "✅" : "⬜";
      const enfRinonesNo = docEnfRinonesRad === "No" ? "✅" : "⬜";

      const enfEstomagoSi = docEnfEstomagoRad === "Si" ? "✅" : "⬜";
      const enfEstomagoNo = docEnfEstomagoRad === "No" ? "✅" : "⬜";

      const diabetSi = docDiabetRad === "Si" ? "✅" : "⬜";
      const diabetNo = docDiabetRad === "No" ? "✅" : "⬜";

      const hipertSi = docHipertRad === "Si" ? "✅" : "⬜";
      const hipertNo = docHipertRad === "No" ? "✅" : "⬜";

      const asmaSi = docAsmaRad === "Si" ? "✅" : "⬜";
      const asmaNo = docAsmaRad === "No" ? "✅" : "⬜";

      const enfPsiqSi = docEnfPsiqRad === "Si" ? "✅" : "⬜";
      const enfPsiqNo = docEnfPsiqRad === "No" ? "✅" : "⬜";

      const medicacionSi = docMedicacionRad === "Si" ? "✅" : "⬜";
      const medicacionNo = docMedicacionRad === "No" ? "✅" : "⬜";

      const rehabSi = docRehabRad === "Si" ? "✅" : "⬜";
      const rehabNo = docRehabRad === "No" ? "✅" : "⬜";

      doc.setData({
        date: FormatDate(docFecha),
        paciente: docPacie,
        edad: docEdad,
        sexo: docSexo,
        sexoHombre: sexoHombre,
        sexoMujer: sexoMujer,
        direccion: docDirecc,
        poblacion: docPobl,
        pais: docPais,
        tel: docTelefono,
        email: docEmail,
        nombreFamiliar: docNombreFamiliar,
        telFamiliar: docTelFamiliar,
        embarazRad: docEmbarazRad,
        embarazSi: embarazSi,
        embarazNo: embarazNo,
        alergiaRad: docAlergiaRad,
        alergiaSi: alergiaSi,
        alergiaNo: alergiaNo,
        alergiaResp: docAlergiaResp,
        defSensRad: docDefSensRad,
        defSensSi: defSensSi,
        defSensNo: defSensNo,
        defSensResp: docDefSensResp,
        intHospRad: docIntHospRad,
        intHospSi: intHospSi,
        intHospNo: intHospNo,
        intHospCuando: docIntHospCuando,
        intHospMotivo: docIntHospMotivo,
        lesCabezRad: docLesCabezRad,
        lesCabezSi: lesCabezSi,
        lesCabezNo: lesCabezNo,
        lesCabezResp: docLesCabezResp,
        desmRad: docDesmRad,
        desmSi: desmSi,
        desmNo: desmNo,
        desmCuando: docDesmCuando,
        desmTiempo: docDesmTiempo,
        desmMotivo: docDesmMotivo,
        convRad: docConvRad,
        convSi: convSi,
        convNo: convNo,
        convCuando: docConvCuando,
        convCuantas: docConvCuantas,
        enfCorazonRad: docEnfCorazonRad,
        enfCorazonSi: enfCorazonSi,
        enfCorazonNo: enfCorazonNo,
        enfCorazonResp: docEnfCorazonResp,
        enfHigadoRad: docEnfHigadoRad,
        enfHigadoSi: enfHigadoSi,
        enfHigadoNo: enfHigadoNo,
        enfHigadoResp: docEnfHigadoResp,
        enfPulmonesRad: docEnfPulmonesRad,
        enfPulmonesSi: enfPulmonesSi,
        enfPulmonesNo: enfPulmonesNo,
        enfPulmonesResp: docEnfPulmonesResp,
        enfRinonesRad: docEnfRinonesRad,
        enfRinonesSi: enfRinonesSi,
        enfRinonesNo: enfRinonesNo,
        enfRinonesResp: docEnfRinonesResp,
        enfEstomagoRad: docEnfEstomagoRad,
        enfEstomagoSi: enfEstomagoSi,
        enfEstomagoNo: enfEstomagoNo,
        enfEstomagoResp: docEnfEstomagoResp,
        diabetRad: docDiabetRad,
        diabetSi: diabetSi,
        diabetNo: diabetNo,
        hipertRad: docHipertRad,
        hipertSi: hipertSi,
        hipertNo: hipertNo,
        hipertResp: docHipertResp,
        asmaRad: docAsmaRad,
        asmaSi: asmaSi,
        asmaNo: asmaNo,
        enfPsiqRad: docEnfPsiqRad,
        enfPsiqSi: enfPsiqSi,
        enfPsiqNo: enfPsiqNo,
        enfPsiqResp: docEnfPsiqResp,
        metadonaDiaria: docMetadonaDiaria,
        metadonaCuando: docMetadonaCuando,
        heroinaDiaria: docHeroinaDiaria,
        heroinaCuando: docHeroinaCuando,
        codeinaDiaria: docCodeinaDiaria,
        codeinaCuando: docCodeinaCuando,
        morfinaDiaria: docMorfinaDiaria,
        morfinaCuando: docMorfinaCuando,
        cocainaDiaria: docCocainaDiaria,
        cocainaCuando: docCocainaCuando,
        anfetaminasDiaria: docAnfetaminasDiaria,
        anfetaminasCuando: docAnfetaminasCuando,
        lsdDiaria: docLsdDiaria,
        lsdCuando: docLsdCuando,
        extasisDiaria: docExtasisDiaria,
        extasisCuando: docExtasisCuando,
        cannabisDiaria: docCannabisDiaria,
        cannabisCuando: docCannabisCuando,
        benzodiazepinasUnoDiaria: docBenzodiazepinasUnoDiaria,
        benzodiazepinasUnoCuando: docBenzodiazepinasUnoCuando,
        benzodiazepinasDosDiaria: docBenzodiazepinasDosDiaria,
        benzodiazepinasDosCuando: docBenzodiazepinasDosCuando,
        benzodiazepinasTresDiaria: docBenzodiazepinasTresDiaria,
        benzodiazepinasTresCuando: docBenzodiazepinasTresCuando,
        whiskyDiaria: docWhiskyDiaria,
        whiskyCuando: docWhiskyCuando,
        vinoDiaria: docVinoDiaria,
        vinoCuando: docVinoCuando,
        cervezaDiaria: docCervezaDiaria,
        cervezaCuando: docCervezaCuando,
        alcoholOtrosDiaria: docAlcoholOtrosDiaria,
        alcoholOtrosCuando: docAlcoholOtrosCuando,
        otraDrogaUnoDiaria: docOtraDrogaUnoDiaria,
        otraDrogaUnoCuando: docOtraDrogaUnoCuando,
        otraDrogaDosDiaria: docOtraDrogaDosDiaria,
        otraDrogaDosCuando: docOtraDrogaDosCuando,
        infoConsDroga: docInfoConsDroga,
        medicacionRad: docMedicacionRad,
        medicacionSi: medicacionSi,
        medicacionNo: medicacionNo,
        medicacionResp: docMedicacionResp,
        rehabRad: docRehabRad,
        rehabSi: rehabSi,
        rehabNo: rehabNo,
        rehabResp: docRehabResp,
      });

      doc.render();
      const output = doc.getZip().generate({
        type: "blob",
        mimeType:
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      });

      saveAs(output, "cuestionario-salud.docx");
    } catch (error) {
      console.error("Error al generar el documento .docx", error);
    }
  };

  useEffect(() => {
    updateData(data);
    setShowDocxLink(true);
  }, [
    docFecha,
    docPacie,
    docEdad,
    docSexo,
    docDirecc,
    docPobl,
    docPais,
    docTelefono,
    docEmail,
    docNombreFamiliar,
    docTelFamiliar,
    docEmbarazRad,
    docAlergiaRad,
    docAlergiaResp,
    docDefSensRad,
    docDefSensResp,
    docIntHospRad,
    docIntHospCuando,
    docIntHospMotivo,
    docLesCabezRad,
    docLesCabezResp,
    docDesmRad,
    docDesmCuando,
    docDesmTiempo,
    docDesmMotivo,
    docConvRad,
    docConvCuando,
    docConvCuantas,
    docEnfCorazonRad,
    docEnfCorazonResp,
    docEnfHigadoRad,
    docEnfHigadoResp,
    docEnfPulmonesRad,
    docEnfPulmonesResp,
    docEnfRinonesRad,
    docEnfRinonesResp,
    docEnfEstomagoRad,
    docEnfEstomagoResp,
    docDiabetRad,
    docHipertRad,
    docHipertResp,
    docAsmaRad,
    docEnfPsiqRad,
    docEnfPsiqResp,
    docMetadonaDiaria,
    docMetadonaCuando,
    docHeroinaDiaria,
    docHeroinaCuando,
    docCodeinaDiaria,
    docCodeinaCuando,
    docMorfinaDiaria,
    docMorfinaCuando,
    docCocainaDiaria,
    docCocainaCuando,
    docAnfetaminasDiaria,
    docAnfetaminasCuando,
    docLsdDiaria,
    docLsdCuando,
    docExtasisDiaria,
    docExtasisCuando,
    docCannabisDiaria,
    docCannabisCuando,
    docBenzodiazepinasUnoDiaria,
    docBenzodiazepinasUnoCuando,
    docBenzodiazepinasDosDiaria,
    docBenzodiazepinasDosCuando,
    docBenzodiazepinasTresDiaria,
    docBenzodiazepinasTresCuando,
    docWhiskyDiaria,
    docWhiskyCuando,
    docVinoDiaria,
    docVinoCuando,
    docCervezaDiaria,
    docCervezaCuando,
    docAlcoholOtrosDiaria,
    docAlcoholOtrosCuando,
    docOtraDrogaUnoDiaria,
    docOtraDrogaUnoCuando,
    docOtraDrogaDosDiaria,
    docOtraDrogaDosCuando,
    docInfoConsDroga,
    docMedicacionRad,
    docMedicacionResp,
    docRehabRad,
    docRehabResp,
  ]);

  return (
    <>
      <div className="docFormCOntainer">
        <div className="grid--2col">
          <div className="field">
            <label htmlFor="docFecha">Fecha</label>
            <div className="control">
              <input
                className="input"
                id="docFecha"
                
                type="date"
                value={docFecha}
                onChange={(e) => setDocFecha(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docPacie">Paciente</label>
            <div className="control">
              <input
                className="input"
                id="docPacie"
                
                type="text"
                value={docPacie}
                onChange={(e) => setDocPacie(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docEdad">Edad</label>
            <div className="control">
              <input
                className="input"
                id="docEdad"
                
                type="text"
                value={docEdad}
                onChange={(e) => setDocEdad(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docSexo">Sexo</label>
            <div className="control">
              <div className="select">
                <select
                  className="select"
                  id="docSexo"
                  
                  name="docSexo"
                  value={docSexo}
                >
                  <option disabled value="">
                    -- Selecciona una opción --
                  </option>
                  <option value="hombre">Hombre</option>
                  <option value="mujer">Mujer</option>
                </select>
              </div>
            </div>
          </div>
          <div className="field">
            <label htmlFor="docDirecc">Dirección</label>
            <div className="control">
              <input
                className="input"
                id="docDirecc"
                
                type="text"
                value={docDirecc}
                onChange={(e) => setDocDirecc(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docPobl">Población</label>
            <div className="control">
              <input
                className="input"
                id="docPobl"
                
                type="text"
                value={docPobl}
                onChange={(e) => setDocPobl(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docPais">País</label>
            <div className="control">
              <input
                className="input"
                id="docPais"
                
                type="text"
                value={docPais}
                onChange={(e) => setDocPais(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docTelefono">Teléfono</label>
            <div className="control">
              <input
                className="input"
                id="docTelefono"
                
                type="tel"
                value={docTelefono}
                onChange={(e) => setDocTelefono(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docEmail">Email</label>
            <div className="control">
              <input
                className="input"
                id="docEmail"
                
                type="email"
                value={docEmail}
                onChange={(e) => setDocEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docNombreFamiliar">Nombre de Familiar</label>
            <div className="control">
              <input
                className="input"
                id="docNombreFamiliar"
                
                type="text"
                value={docNombreFamiliar}
                onChange={(e) => setDocNombreFamiliar(e.target.value)}
              />
            </div>
          </div>
          <div className="field">
            <label htmlFor="docTelFamiliar">Teléfono de Familiar</label>
            <div className="control">
              <input
                className="input"
                id="docTelFamiliar"
                
                type="tel"
                value={docTelFamiliar}
                onChange={(e) => setDocTelFamiliar(e.target.value)}
              />
            </div>
          </div>
        </div>

        <h3>Informacion Confidencial</h3>
          <div className="grid--2col">
            {docSexo === "mujer" && (
              <div className="field key" data-key={docEmbarazRad?.toString()}>
                <div className="control">
                  <label className="radio-title">
                    Solo si el paciente es mujer: ¿está usted embarazada?
                  </label>
                  <label className="radio" htmlFor="docEmbarazSi">
                    <input
                      id="docEmbarazSi"
                      name="docEmbarazRad"
                      type="radio"
                      value="Si"
                      checked={docEmbarazRad === "Si"}
                      onChange={(e) => setDocEmbarazRad(e.target.value)}
                    />
                    Si
                  </label>
                  <label className="radio" htmlFor="docEmbarazNo">
                    <input
                      id="docEmbarazNo"
                      name="docEmbarazRad"
                      type="radio"
                      value="No"
                      checked={docEmbarazRad === "No"}
                      onChange={(e) => setDocEmbarazRad(e.target.value)}
                    />
                    No
                  </label>
                </div>
              </div>
            )}
            <div className="field key" data-key={docAlergiaRad?.toString()}>
              <div className="control">
                <label className="radio-title">¿Sufre alguna alergia?</label>
                <label className="radio" htmlFor="docAlergiaRadSi">
                  <input
                    id="docAlergiaRadSi"
                    name="docAlergiaRad"
                    type="radio"
                    value="Si"
                    checked={docAlergiaRad === "Si"}
                    onChange={(e) => setDocAlergiaRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docAlergiaRadNo">
                  <input
                    id="docAlergiaRadNo"
                    name="docAlergiaRad"
                    type="radio"
                    value="No"
                    checked={docAlergiaRad === "No"}
                    onChange={(e) => setDocAlergiaRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docAlergiaResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docAlergiaResp"
                  
                  type="text"
                  value={docAlergiaResp}
                  onChange={(e) => setDocAlergiaResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={docDefSensRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Sufre alguna deficiencia sensorial?
                </label>
                <label className="radio" htmlFor="docDefSensSi">
                  <input
                    id="docDefSensSi"
                    name="docDefSensRad"
                    type="radio"
                    value="Si"
                    checked={docDefSensRad === "Si"}
                    onChange={(e) => setDocDefSensRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docDefSensNo">
                  <input
                    id="docDefSensNo"
                    name="docDefSensRad"
                    type="radio"
                    value="No"
                    checked={docDefSensRad === "No"}
                    onChange={(e) => setDocDefSensRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docDefSensResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docDefSensResp"
                  
                  type="text"
                  value={docDefSensResp}
                  onChange={(e) => setDocDefSensResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={docIntHospRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Se ha sometido a una intervención hospitalaria?
                </label>
                <label className="radio" htmlFor="docIntHospSi">
                  <input
                    id="docIntHospSi"
                    name="docIntHospRad"
                    type="radio"
                    value="Si"
                    checked={docIntHospRad === "Si"}
                    onChange={(e) => setDocIntHospRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docIntHospNo">
                  <input
                    id="docIntHospNo"
                    name="docIntHospRad"
                    type="radio"
                    value="No"
                    checked={docIntHospRad === "No"}
                    onChange={(e) => setDocIntHospRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field initial-col">
              <p>Si la respuesta es Sí, por favor especifique:</p>
            </div>
            <div className="field initial-col">
              <label htmlFor="docIntHospCuando">Cuando:</label>
              <div className="control">
                <input
                  className="input"
                  id="docIntHospCuando"
                  
                  type="text"
                  value={docIntHospCuando}
                  onChange={(e) => setDocIntHospCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docIntHospMotivo">Motivo:</label>
              <div className="control">
                <input
                  className="input"
                  id="docIntHospMotivo"
                  
                  type="text"
                  value={docIntHospMotivo}
                  onChange={(e) => setDocIntHospMotivo(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={docLesCabezRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Alguna vez ha sufrido una lesión en la cabeza?
                </label>
                <label className="radio" htmlFor="docLesCabezSi">
                  <input
                    id="docLesCabezSi"
                    name="docLesCabezRad"
                    type="radio"
                    value="Si"
                    checked={docLesCabezRad === "Si"}
                    onChange={(e) => setDocLesCabezRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docLesCabezNo">
                  <input
                    id="docLesCabezNo"
                    name="docLesCabezRad"
                    type="radio"
                    value="No"
                    checked={docLesCabezRad === "No"}
                    onChange={(e) => setDocLesCabezRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docLesCabezResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docLesCabezResp"
                  
                  type="text"
                  value={docLesCabezResp}
                  onChange={(e) => setDocLesCabezResp(e.target.value)}
                />
              </div>
            </div>

            <div className="field key" data-key={docDesmRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Alguna vez se desmayó, ha perdido el conocimiento o estuvo en
                  coma?
                </label>
                <label className="radio" htmlFor="docDesmSi">
                  <input
                    id="docDesmSi"
                    name="docDesmRad"
                    type="radio"
                    value="Si"
                    checked={docDesmRad === "Si"}
                    onChange={(e) => setDocDesmRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docDesmNo">
                  <input
                    id="docDesmNo"
                    name="docDesmRad"
                    type="radio"
                    value="No"
                    checked={docDesmRad === "No"}
                    onChange={(e) => setDocDesmRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="initial-col">
              <p>Si la respuesta es Sí, por favor especifique:</p>
            </div>
            <div className="field initial-col">
              <label htmlFor="docDesmCuando">Cuando:</label>
              <div className="control">
                <input
                  className="input"
                  id="docDesmCuando"
                  
                  type="text"
                  value={docDesmCuando}
                  onChange={(e) => setDocDesmCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docDesmTiempo">Cuanto tiempo:</label>
              <div className="control">
                <input
                  className="input"
                  id="docDesmTiempo"
                  
                  type="text"
                  value={docDesmTiempo}
                  onChange={(e) => setDocDesmTiempo(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docDesmMotivo">Motivo:</label>
              <div className="control">
                <input
                  className="input"
                  id="docDesmMotivo"
                  
                  type="text"
                  value={docDesmMotivo}
                  onChange={(e) => setDocDesmMotivo(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={docConvRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Alguna vez ha tenido convulsiones?
                </label>
                <label className="radio" htmlFor="docConvSi">
                  <input
                    id="docConvSi"
                    name="docConvRad"
                    type="radio"
                    value="Si"
                    checked={docConvRad === "Si"}
                    onChange={(e) => setDocConvRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docConvNo">
                  <input
                    id="docConvNo"
                    name="docConvRad"
                    type="radio"
                    value="No"
                    checked={docConvRad === "No"}
                    onChange={(e) => setDocConvRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="initial-col">
              <p>Si la respuesta es Sí, por favor especifique:</p>
            </div>
            <div className="field initial-col">
              <label htmlFor="docConvCuando">Cuándo:</label>
              <div className="control">
                <input
                  className="input"
                  id="docConvCuando"
                  
                  type="text"
                  value={docConvCuando}
                  onChange={(e) => setDocConvCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docConvCuantas">Cuántas veces:</label>
              <div className="control">
                <input
                  className="input"
                  id="docConvCuantas"
                  
                  type="text"
                  value={docConvCuantas}
                  onChange={(e) => setDocConvCuantas(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="grid--2col">
            <div className="field initial-col">
              <p>Sufre alguna enfermedad de:</p>
            </div>
            <div className="field key" data-key={docEnfCorazonRad?.toString()}>
              <div className="control">
                <label className="radio-title">Corazón</label>
                <label className="radio" htmlFor="docEnfCorazonSi">
                  <input
                    id="docEnfCorazonSi"
                    name="docEnfCorazonRad"
                    type="radio"
                    value="Si"
                    checked={docEnfCorazonRad === "Si"}
                    onChange={(e) => setDocEnfCorazonRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docEnfCorazonNo">
                  <input
                    id="docEnfCorazonNo"
                    name="docEnfCorazonRad"
                    type="radio"
                    value="No"
                    checked={docEnfCorazonRad === "No"}
                    onChange={(e) => setDocEnfCorazonRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docEnfCorazonResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docEnfCorazonResp"
                  
                  type="text"
                  value={docEnfCorazonResp}
                  onChange={(e) => setDocEnfCorazonResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={docEnfHigadoRad?.toString()}>
              <div className="control">
                <label className="radio-title">Hígado</label>
                <label className="radio" htmlFor="docEnfHigadoSi">
                  <input
                    id="docEnfHigadoSi"
                    name="docEnfHigadoRad"
                    type="radio"
                    value="Si"
                    checked={docEnfHigadoRad === "Si"}
                    onChange={(e) => setDocEnfHigadoRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docEnfHigadoNo">
                  <input
                    id="docEnfHigadoNo"
                    name="docEnfHigadoRad"
                    type="radio"
                    value="No"
                    checked={docEnfHigadoRad === "No"}
                    onChange={(e) => setDocEnfHigadoRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docEnfHigadoResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docEnfHigadoResp"
                  
                  type="text"
                  value={docEnfHigadoResp}
                  onChange={(e) => setDocEnfHigadoResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={docEnfPulmonesRad?.toString()}>
              <div className="control">
                <label className="radio-title">Pulmones</label>
                <label className="radio" htmlFor="docEnfPulmonesSi">
                  <input
                    id="docEnfPulmonesSi"
                    name="docEnfPulmonesRad"
                    type="radio"
                    value="Si"
                    checked={docEnfPulmonesRad === "Si"}
                    onChange={(e) => setDocEnfPulmonesRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docEnfPulmonesNo">
                  <input
                    id="docEnfPulmonesNo"
                    name="docEnfPulmonesRad"
                    type="radio"
                    value="No"
                    checked={docEnfPulmonesRad === "No"}
                    onChange={(e) => setDocEnfPulmonesRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docEnfPulmonesResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docEnfPulmonesResp"
                  
                  type="text"
                  value={docEnfPulmonesResp}
                  onChange={(e) => setDocEnfPulmonesResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={docEnfRinonesRad?.toString()}>
              <div className="control">
                <label className="radio-title">Riñones</label>
                <label className="radio" htmlFor="docEnfRinonesSi">
                  <input
                    id="docEnfRinonesSi"
                    name="docEnfRinonesRad"
                    type="radio"
                    value="Si"
                    checked={docEnfRinonesRad === "Si"}
                    onChange={(e) => setDocEnfRinonesRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docEnfRinonesNo">
                  <input
                    id="docEnfRinonesNo"
                    name="docEnfRinonesRad"
                    type="radio"
                    value="No"
                    checked={docEnfRinonesRad === "No"}
                    onChange={(e) => setDocEnfRinonesRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docEnfRinonesResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docEnfRinonesResp"
                  
                  type="text"
                  value={docEnfRinonesResp}
                  onChange={(e) => setDocEnfRinonesResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={docEnfEstomagoRad?.toString()}>
              <div className="control">
                <label className="radio-title">Estómago</label>
                <label className="radio" htmlFor="docEnfEstomagoSi">
                  <input
                    id="docEnfEstomagoSi"
                    name="docEnfEstomagoRad"
                    type="radio"
                    value="Si"
                    checked={docEnfEstomagoRad === "Si"}
                    onChange={(e) => setDocEnfEstomagoRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docEnfEstomagoNo">
                  <input
                    id="docEnfEstomagoNo"
                    name="docEnfEstomagoRad"
                    type="radio"
                    value="No"
                    checked={docEnfEstomagoRad === "No"}
                    onChange={(e) => setDocEnfEstomagoRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docEnfEstomagoResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docEnfEstomagoResp"
                  
                  type="text"
                  value={docEnfEstomagoResp}
                  onChange={(e) => setDocEnfEstomagoResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={docDiabetRad?.toString()}>
              <div className="control">
                <label className="radio-title">¿Es usted diabético?</label>
                <label className="radio" htmlFor="docDiabetSi">
                  <input
                    id="docDiabetSi"
                    name="docDiabetRad"
                    type="radio"
                    value="Si"
                    checked={docDiabetRad === "Si"}
                    onChange={(e) => setDocDiabetRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docDiabetNo">
                  <input
                    id="docDiabetNo"
                    name="docDiabetRad"
                    type="radio"
                    value="No"
                    checked={docDiabetRad === "No"}
                    onChange={(e) => setDocDiabetRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field key" data-key={docHipertRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Sufre hipertensión o alguna otra enfermedad cardiovascular?
                </label>
                <label className="radio" htmlFor="docHipertSi">
                  <input
                    id="docHipertSi"
                    name="docHipertRad"
                    type="radio"
                    value="Si"
                    checked={docHipertRad === "Si"}
                    onChange={(e) => setDocHipertRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docHipertNo">
                  <input
                    id="docHipertNo"
                    name="docHipertRad"
                    type="radio"
                    value="No"
                    checked={docHipertRad === "No"}
                    onChange={(e) => setDocHipertRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docHipertResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docHipertResp"
                  
                  type="text"
                  value={docHipertResp}
                  onChange={(e) => setDocHipertResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={docAsmaRad?.toString()}>
              <div className="control">
                <label className="radio-title">¿Tiene asma?</label>
                <label className="radio" htmlFor="docAsmaSi">
                  <input
                    id="docAsmaSi"
                    name="docAsmaRad"
                    type="radio"
                    value="Si"
                    checked={docAsmaRad === "Si"}
                    onChange={(e) => setDocAsmaRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docAsmaNo">
                  <input
                    id="docAsmaNo"
                    name="docAsmaRad"
                    type="radio"
                    value="No"
                    checked={docAsmaRad === "No"}
                    onChange={(e) => setDocAsmaRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field key" data-key={docEnfPsiqRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Alguna vez ha sufrido una enfermedad psiquiátrica?
                </label>
                <label className="radio" htmlFor="docEnfPsiqSi">
                  <input
                    id="docEnfPsiqSi"
                    name="docEnfPsiqRad"
                    type="radio"
                    value="Si"
                    checked={docEnfPsiqRad === "Si"}
                    onChange={(e) => setDocEnfPsiqRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docEnfPsiqNo">
                  <input
                    id="docEnfPsiqNo"
                    name="docEnfPsiqRad"
                    type="radio"
                    value="No"
                    checked={docEnfPsiqRad === "No"}
                    onChange={(e) => setDocEnfPsiqRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docEnfPsiqResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docEnfPsiqResp"
                  
                  type="text"
                  value={docEnfPsiqResp}
                  onChange={(e) => setDocEnfPsiqResp(e.target.value)}
                />
              </div>
            </div>
          </div>

          <h3>Abuso de drogas en la actualidad</h3>
          <div className="grid--2col">
            <div className="field">
              <label htmlFor="docMetadonaDiaria">
                Metadona - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docMetadonaDiaria"
                  
                  type="text"
                  value={docMetadonaDiaria}
                  onChange={(e) => setDocMetadonaDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docMetadonaCuando">Metadona - Desde Cuando</label>
              <div className="control">
                <input
                  className="input"
                  id="docMetadonaCuando"
                  
                  type="text"
                  value={docMetadonaCuando}
                  onChange={(e) => setDocMetadonaCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docHeroinaDiaria">
                Heroína - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docHeroinaDiaria"
                  
                  type="text"
                  value={docHeroinaDiaria}
                  onChange={(e) => setDocHeroinaDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docHeroinaCuando">Heroína - Desde Cuando</label>
              <div className="control">
                <input
                  className="input"
                  id="docHeroinaCuando"
                  
                  type="text"
                  value={docHeroinaCuando}
                  onChange={(e) => setDocHeroinaCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docCodeinaDiaria">
                Codeína - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docCodeinaDiaria"
                  
                  type="text"
                  value={docCodeinaDiaria}
                  onChange={(e) => setDocCodeinaDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docCodeinaCuando">Codeína - Desde Cuando</label>
              <div className="control">
                <input
                  className="input"
                  id="docCodeinaCuando"
                  
                  type="text"
                  value={docCodeinaCuando}
                  onChange={(e) => setDocCodeinaCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docMorfinaDiaria">
                Morfina - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docMorfinaDiaria"
                  
                  type="text"
                  value={docMorfinaDiaria}
                  onChange={(e) => setDocMorfinaDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docMorfinaCuando">Morfina - Desde Cuando</label>
              <div className="control">
                <input
                  className="input"
                  id="docMorfinaCuando"
                  
                  type="text"
                  value={docMorfinaCuando}
                  onChange={(e) => setDocMorfinaCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docCocainaDiaria">
                Cocaína - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docCocainaDiaria"
                  
                  type="text"
                  value={docCocainaDiaria}
                  onChange={(e) => setDocCocainaDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docCocainaCuando">Cocaína - Desde Cuando</label>
              <div className="control">
                <input
                  className="input"
                  id="docCocainaCuando"
                  
                  type="text"
                  value={docCocainaCuando}
                  onChange={(e) => setDocCocainaCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docAnfetaminasDiaria">
                Anfetaminas - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docAnfetaminasDiaria"
                  
                  type="text"
                  value={docAnfetaminasDiaria}
                  onChange={(e) => setDocAnfetaminasDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docAnfetaminasCuando">
                Anfetaminas - Desde Cuando
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docAnfetaminasCuando"
                  
                  type="text"
                  value={docAnfetaminasCuando}
                  onChange={(e) => setDocAnfetaminasCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docLsdDiaria">LSD - Cantidad Diaria</label>
              <div className="control">
                <input
                  className="input"
                  id="docLsdDiaria"
                  
                  type="text"
                  value={docLsdDiaria}
                  onChange={(e) => setDocLsdDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docLsdCuando">LSD - Desde Cuando</label>
              <div className="control">
                <input
                  className="input"
                  id="docLsdCuando"
                  
                  type="text"
                  value={docLsdCuando}
                  onChange={(e) => setDocLsdCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docExtasisDiaria">
                Éxtasis - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docExtasisDiaria"
                  
                  type="text"
                  value={docExtasisDiaria}
                  onChange={(e) => setDocExtasisDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docExtasisCuando">Éxtasis - Desde Cuando</label>
              <div className="control">
                <input
                  className="input"
                  id="docExtasisCuando"
                  
                  type="text"
                  value={docExtasisCuando}
                  onChange={(e) => setDocExtasisCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docCannabisDiaria">
                Cannabis - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docCannabisDiaria"
                  
                  type="text"
                  value={docCannabisDiaria}
                  onChange={(e) => setDocCannabisDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docCannabisCuando">Cannabis - Desde Cuando</label>
              <div className="control">
                <input
                  className="input"
                  id="docCannabisCuando"
                  
                  type="text"
                  value={docCannabisCuando}
                  onChange={(e) => setDocCannabisCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docBenzodiazepinasUnoDiaria">
                Benzodiacepinas - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docBenzodiazepinasUnoDiaria"
                  
                  type="text"
                  value={docBenzodiazepinasUnoDiaria}
                  onChange={(e) =>
                    setDocBenzodiazepinasUnoDiaria(e.target.value)
                  }
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docBenzodiazepinasUnoCuando">
                Benzodiacepinas - Desde Cuando
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docBenzodiazepinasUnoCuando"
                  
                  type="text"
                  value={docBenzodiazepinasUnoCuando}
                  onChange={(e) =>
                    setDocBenzodiazepinasUnoCuando(e.target.value)
                  }
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docBenzodiazepinasDosDiaria">
                Benzodiacepinas - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docBenzodiazepinasDosDiaria"
                  
                  type="text"
                  value={docBenzodiazepinasDosDiaria}
                  onChange={(e) =>
                    setDocBenzodiazepinasDosDiaria(e.target.value)
                  }
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docBenzodiazepinasDosCuando">
                Benzodiacepinas - Desde Cuando
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docBenzodiazepinasDosCuando"
                  
                  type="text"
                  value={docBenzodiazepinasDosCuando}
                  onChange={(e) =>
                    setDocBenzodiazepinasDosCuando(e.target.value)
                  }
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docBenzodiazepinasTresDiaria">
                Benzodiacepinas - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docBenzodiazepinasTresDiaria"
                  
                  type="text"
                  value={docBenzodiazepinasTresDiaria}
                  onChange={(e) =>
                    setDocBenzodiazepinasTresDiaria(e.target.value)
                  }
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docBenzodiazepinasTresCuando">
                Benzodiacepinas - Desde Cuando
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docBenzodiazepinasTresCuando"
                  
                  type="text"
                  value={docBenzodiazepinasTresCuando}
                  onChange={(e) =>
                    setDocBenzodiazepinasTresCuando(e.target.value)
                  }
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docWhiskyDiaria">
                Alcohol (whisky) - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docWhiskyDiaria"
                  
                  type="text"
                  value={docWhiskyDiaria}
                  onChange={(e) => setDocWhiskyDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docWhiskyCuando">
                Alcohol (whisky) - Desde Cuando
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docWhiskyCuando"
                  
                  type="text"
                  value={docWhiskyCuando}
                  onChange={(e) => setDocWhiskyCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docVinoDiaria">
                Alcohol (vino) - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docVinoDiaria"
                  
                  type="text"
                  value={docVinoDiaria}
                  onChange={(e) => setDocVinoDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docVinoCuando">
                Alcohol (vino) - Desde Cuando
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docVinoCuando"
                  
                  type="text"
                  value={docVinoCuando}
                  onChange={(e) => setDocVinoCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docCervezaDiaria">
                Alcohol (cerveza) - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docCervezaDiaria"
                  
                  type="text"
                  value={docCervezaDiaria}
                  onChange={(e) => setDocCervezaDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docCervezaCuando">
                Alcohol (cerveza) - Desde Cuando
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docCervezaCuando"
                  
                  type="text"
                  value={docCervezaCuando}
                  onChange={(e) => setDocCervezaCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docAlcoholOtrosDiaria">
                Alcohol (otros) - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docAlcoholOtrosDiaria"
                  
                  type="text"
                  value={docAlcoholOtrosDiaria}
                  onChange={(e) => setDocAlcoholOtrosDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docAlcoholOtrosCuando">
                Alcohol (otros) - Desde Cuando
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docAlcoholOtrosCuando"
                  
                  type="text"
                  value={docAlcoholOtrosCuando}
                  onChange={(e) => setDocAlcoholOtrosCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docOtraDrogaUnoDiaria">
                Otra droga - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docOtraDrogaUnoDiaria"
                  
                  type="text"
                  value={docOtraDrogaUnoDiaria}
                  onChange={(e) => setDocOtraDrogaUnoDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docOtraDrogaUnoCuando">
                Otra droga - Desde Cuando
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docOtraDrogaUnoCuando"
                  
                  type="text"
                  value={docOtraDrogaUnoCuando}
                  onChange={(e) => setDocOtraDrogaUnoCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docOtraDrogaDosDiaria">
                Otra droga - Cantidad Diaria
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docOtraDrogaDosDiaria"
                  
                  type="text"
                  value={docOtraDrogaDosDiaria}
                  onChange={(e) => setDocOtraDrogaDosDiaria(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docOtraDrogaDosCuando">
                Otra droga - Desde Cuando
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docOtraDrogaDosCuando"
                  
                  type="text"
                  value={docOtraDrogaDosCuando}
                  onChange={(e) => setDocOtraDrogaDosCuando(e.target.value)}
                />
              </div>
            </div>
            <div className="field">
              <label htmlFor="docInfoConsDroga">
                Información adicional sobre su consumo de drogas:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docInfoConsDroga"
                  
                  type="text"
                  value={docInfoConsDroga}
                  onChange={(e) => setDocInfoConsDroga(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="grid--2col">
            <div className="field key" data-key={docMedicacionRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Está tomando algún tipo de medicación?
                </label>
                <label className="radio" htmlFor="docMedicacionSi">
                  <input
                    id="docMedicacionSi"
                    name="docMedicacionRad"
                    type="radio"
                    value="Si"
                    checked={docMedicacionRad === "Si"}
                    onChange={(e) => setDocMedicacionRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docMedicacionNo">
                  <input
                    id="docMedicacionNo"
                    name="docMedicacionRad"
                    type="radio"
                    value="No"
                    checked={docMedicacionRad === "No"}
                    onChange={(e) => setDocMedicacionRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docMedicacionResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docMedicacionResp"
                  
                  type="text"
                  value={docMedicacionResp}
                  onChange={(e) => setDocMedicacionResp(e.target.value)}
                />
              </div>
            </div>
            <div className="field key" data-key={docRehabRad?.toString()}>
              <div className="control">
                <label className="radio-title">
                  ¿Tiene previsto realizar algún plan de rehabilitación
                  (seguimiento psicológico) después de su tratamiento de
                  desintoxicación?
                </label>
                <label className="radio" htmlFor="docRehabSi">
                  <input
                    id="docRehabSi"
                    name="docRehabRad"
                    type="radio"
                    value="Si"
                    checked={docRehabRad === "Si"}
                    onChange={(e) => setDocRehabRad(e.target.value)}
                  />
                  Si
                </label>
                <label className="radio" htmlFor="docRehabNo">
                  <input
                    id="docRehabNo"
                    name="docRehabRad"
                    type="radio"
                    value="No"
                    checked={docRehabRad === "No"}
                    onChange={(e) => setDocRehabRad(e.target.value)}
                  />
                  No
                </label>
              </div>
            </div>
            <div className="field">
              <label htmlFor="docRehabResp">
                Si la respuesta es Sí, por favor especifique:
              </label>
              <div className="control">
                <input
                  className="input"
                  id="docRehabResp"
                  
                  type="text"
                  value={docRehabResp}
                  onChange={(e) => setDocRehabResp(e.target.value)}
                />
              </div>
            </div>
          </div>
      </div>

      <div className="btn-dwnld">
        {showDocxLink && (
          <a className="button is-link" href="#!" onClick={generateDocx}>
            Descargar DOCX
          </a>
        )}
      </div>
    </>
  );
}
